import fatFooterStyles from './fat-footer';
